
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/youth-discount",
      function () {
        return require("private-next-pages/health-insurance/youth-discount/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/youth-discount"])
      });
    }
  